<template>
  <div class="body_monban" >
    <el-tabs  style="height: 200px;" v-model="activeName">
      <el-tab-pane label="门店角色管理" name="mendianJuese"><jueseCom juese_type="1"></jueseCom></el-tab-pane>
    <el-tab-pane label="管理员角色管理" name="adminJuese"><jueseCom juese_type="2"></jueseCom></el-tab-pane>

  </el-tabs>

  </div>
</template>
<style>
.body_moban{
  padding-top: 100px;
}
</style>
<script>
 
import jueseCom from './juese_com.vue';
 
export default {
  components: {
    jueseCom: jueseCom
  },

  data() {
    return {
      // 获取用户列表参数
      activeName: 'adminJuese'
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
